import { Empty, Flex } from "antd";
import { FC } from "react";
import { Product, TaskUpdateProductBalances } from "tm-shared/types";

import { InfoRowList } from "@/components/TasksModals/components/InfoRowList";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";

import { ProductCard } from "../components/ProductCard";
import { TaskViewModal } from "../TaskViewModal";

interface PromoProductWithRest extends Product {
    rest: number;
}

interface UpdateProductBalancesViewModalProps {
    task: TaskUpdateProductBalances;
    onClose: () => void;
}

export const UpdateProductBalancesViewModal: FC<
    UpdateProductBalancesViewModalProps
> = ({ task, onClose }) => {
    const { products } = useAppSelector((s) => s.offline);

    const payload = task?.payload;
    const completedAt = task?.completedAt;

    if (!payload || !completedAt) return null;

    const restProducts = payload?.restProducts;

    const currentProducts = Object.entries(restProducts).reduce(
        (acc: PromoProductWithRest[], [barcode, rest]) => {
            const currentProduct = products[barcode];

            if (currentProduct) acc.push({ ...currentProduct, rest });

            return acc;
        },
        [],
    );

    const infoRows = [
        { label: "Всього товарів:", value: `${currentProducts.length} шт.` },
    ];

    return (
        <TaskViewModal
            title={task.name}
            onClose={onClose}
            taskInfo={task?.info}
        >
            <Flex vertical gap={16}>
                <Flex align="center" justify="space-between" wrap>
                    <PrimaryText fontWeight="600" style={{ fontSize: 16 }}>
                        Оновлені залишки
                    </PrimaryText>

                    <InfoRowList items={infoRows} />
                </Flex>

                {currentProducts.length === 0 ? (
                    <Empty
                        description="Немає продуктів для відображення"
                        style={{ padding: "40px 0" }}
                    />
                ) : (
                    <Flex vertical gap={12}>
                        {currentProducts.map((p) => (
                            <ProductCard key={p.barcode} product={p}>
                                <Flex gap={4}>
                                    <SecondaryText>Залишок:</SecondaryText>

                                    <PrimaryText
                                        fontWeight="500"
                                        fontSize={16}
                                        $textColor="accent"
                                    >
                                        {p.rest} шт.
                                    </PrimaryText>
                                </Flex>
                            </ProductCard>
                        ))}
                    </Flex>
                )}
            </Flex>
        </TaskViewModal>
    );
};
